import { render, staticRenderFns } from "./HomePageGuideDrawer.vue?vue&type=template&id=0e63c4d6"
import script from "./HomePageGuideDrawer.vue?vue&type=script&lang=js"
export * from "./HomePageGuideDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default})
